import React, { useCallback, useRef } from 'react';
import { NativeScrollEvent, NativeSyntheticEvent, ScrollView } from 'react-native';
import { useDispatch } from 'react-redux';
import { useFocusEffect } from '@react-navigation/native';

export const useHandleScroll = (action: (scrollPos: number) => void, scrollX: number) => {
  const dispatch = useDispatch();
  const scrollViewRef = useRef<ScrollView>(null);
  const isManualScrolling = useRef(false);

  useFocusEffect(
    React.useCallback(() => {
      if (scrollViewRef.current && !isManualScrolling.current) {
        scrollViewRef.current.scrollTo({ x: scrollX, y: 0, animated: false });
      }
    }, [scrollX])
  );

  const handleScroll = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const x = event.nativeEvent.contentOffset.x;
    isManualScrolling.current = true;
  }, []);

  const handleScrollEnd = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      const x = event.nativeEvent.contentOffset.x;
      dispatch(action(x));
      setTimeout(() => {
        isManualScrolling.current = false;
      }, 100);
    },
    [dispatch]
  );

  return { handleScroll, handleScrollEnd, scrollViewRef };
};
